/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { ToroLearnIcon } from 'presentation/components/icon';
import { ToroLearnHeader } from 'presentation/components/header';
import { ToroLearnPlaylist } from 'presentation/components/playlist';
import { ToroLearnResourceCard } from 'presentation/components/resource-card';
import { useCourse } from 'presentation/hooks/courses';
import { usePlaylist } from 'presentation/hooks/playlist';
import { ToroCTACard } from 'presentation/components/cta-card';
import { ToroLearnBuyFooter } from 'presentation/components/buy-footer';
import { ToroLearnLockedCard } from 'presentation/components/locked-card';
import { ToroLearnLockedPlayer } from 'presentation/components/locked-player';
import { startBlipChat } from 'data/usecases/startBlipChat';
import './styles.scss';
import { trackingEvent } from 'data/usecases/tracking-event';
import ModalToroForm from 'presentation/components/modal';
import { useUser } from 'presentation/hooks/user';
import VideoPlayer from 'presentation/components/video-player';
import { DayTradeSuceesUnactiveAcccount } from './components/day_trade_success_unactive_account';
import { DayTradeSuceesActiveAcccountAndPlataform } from './components/day_trade_success_active_account_and_plataform';
import { DayTradeSuceesActiveAcccount } from './components/day_trade_success_active_account';

interface IProps {
    slug: string;
    lessonId: string;
    moduleId: string;
}

export const Lesson = (): JSX.Element => {
    const { push } = useHistory();
    const { lessonId, moduleId } = useParams<IProps>();
    const { handleOpenCloseDropdown } = usePlaylist();
    const { course, isLocked, handleCompleteLesson } = useCourse();

    const [counter, setCounter] = useState<number | null>(null);
    const [timeOutInstance, setTimeOutInstance] = useState<NodeJS.Timeout | null>(null);
    const [showNextVideoTransition, setShowNextVideoTransition] = useState(false);
    const [showToroFormModal, setShowToroFormModal] = useState(false);
    const { isRegistered: isRegisteredUser, userInfo, subscriptions } = useUser();
    const [showSuccessScreen, setShowSuccessScreen] = useState(false);
    const module = course?.modules[+moduleId - 1];
    const [canShowActiveSuccess, setShowActiveSuccess] = useState(false);
    const [canShowUnactiveSuccess, setShowUnactiveSuccess] = useState(false);
    const [canShowActiveAndPlataformSuccess, setShowActiveAndPlataform] = useState(false);
    const countLessons = module?.lessons.length;
    const lesson = module?.lessons[+lessonId - 1];
    const idProd = 'e9fad66d-f5f3-45ab-94d2-c0e5c94b224f';
    const idHml = '4e449f40-fef3-4a4a-a36c-ee4788e5c158';
    const isDevOrHml = window.location.hostname.includes('hml') || window.location.hostname.includes('localhost');
    const isFirstModule = +moduleId === 1;

    const isLastModule = +moduleId === course?.modules.length;
    const isFirstLessonOfModule = +lessonId === 1;
    const isLastLessonOfModule = +lessonId === countLessons;

    const nextModule = isLastModule ? course?.modules.length : isLastLessonOfModule ? +moduleId + 1 : +moduleId;
    const prevModule = isFirstModule ? 1 : isFirstLessonOfModule ? +moduleId - 1 : +moduleId;

    const nextLesson = isLastLessonOfModule ? (isLastModule ? null : 1) : +lessonId + 1;
    const prevModuleLesson = isFirstModule ? null : course?.modules[prevModule - 1].lessons.length;
    const prevLesson = isFirstLessonOfModule ? prevModuleLesson : +lessonId - 1;
    const isDayTradeLesson = course?.id === (isDevOrHml ? idHml : idProd) && nextLesson === null;
    const handleOnEnded = () => {
        if (isLastModule) {
            if (isDayTradeLesson) {
                setShowSuccessScreen(true);
            }
            if (!nextModule) return;
        }

        if (!lesson?.isCompleted) handleCompleteLesson(+moduleId - 1, +lessonId - 1);

        if (!isDayTradeLesson) {
            setShowNextVideoTransition(true);
            setTimeOutInstance(
                setTimeout(() => {
                    push({
                        pathname:
                            nextLesson === null ? `/${course?.slug}/${nextModule}/${nextLesson}` : `/${course?.slug}`,
                    });

                    setShowNextVideoTransition(false);
                }, 5000),
            );
        }
    };

    const handleLessonControllsClick = (action: 'prev' | 'next') => {
        trackingEvent.elementClicked({
            productAreaOrigin: 'Aprenda',
            element: action === 'prev' ? 'Aula anterior' : 'Próxima aula',
            group: module?.name,
            step: `${module?.name}/${lesson?.name}`,
            label: lesson?.name,
            text: course?.name,
            timeResponsavel: 'Sky',
        });
    };

    useEffect(() => {
        if (showNextVideoTransition && counter !== null && counter > 0) setTimeout(() => setCounter(counter - 1), 1000);
        if (!showNextVideoTransition) setCounter(5);
    }, [counter, showNextVideoTransition]);

    useEffect(() => {
        if (!course || !course.tags) return;
        if (course.tags.includes(`blip_${moduleId}`) || course.tags.includes('blip_*')) {
            startBlipChat();
        }
    }, [course, moduleId]);
    useEffect(() => {
        const isDayTradeCourse = course?.id === (isDevOrHml ? idHml : idProd);
        const isRegistrad = userInfo?.value.registrationStatus === 16;
        const isPlataform = subscriptions
            ? subscriptions.some(e => e.platformId === '8f3b0d38-a3c3-4b4a-a5d4-13d2b288c726')
            : false;

        setShowActiveSuccess(showSuccessScreen && isRegistrad && isDayTradeCourse && !isPlataform);
        setShowActiveAndPlataform(showSuccessScreen && isRegistrad && isDayTradeCourse && isPlataform);
        setShowUnactiveSuccess(showSuccessScreen && !isRegistrad && isDayTradeCourse && !isPlataform);
    }, [showSuccessScreen]);
    if (!course || !lesson) return <span></span>;

    if (!module || +lessonId > module.lessons.length) {
        return <span></span>;
    }

    return (
        <>
            <ToroLearnHeader />
            {canShowActiveSuccess && <DayTradeSuceesActiveAcccount course={course} />}
            {canShowActiveAndPlataformSuccess && <DayTradeSuceesActiveAcccountAndPlataform course={course} />}
            {canShowUnactiveSuccess && <DayTradeSuceesUnactiveAcccount course={course} />}

            {!showSuccessScreen && (
                <div className={`row lesson ${isLocked ? 'has-footer' : 'has-not-footer'}`}>
                    <div className="col-lg-8">
                        <div className="row bg-gray-ice p-5">
                            <div className="col-lg-12">
                                <div className="lesson-player">
                                    {lesson.videoDistributionUrl && (
                                        <VideoPlayer
                                            transitioning={showNextVideoTransition}
                                            import
                                            width="100%"
                                            height="auto"
                                            key={`${lessonId}-lesson-react-player`}
                                            controls
                                            url={[
                                                {
                                                    src: lesson.videoDistributionUrl,
                                                    type: 'video/mp4',
                                                },
                                            ]}
                                            onEnded={() => handleOnEnded()}
                                            course={course}
                                            module={module}
                                            lesson={lesson}
                                        />
                                    )}
                                    {showNextVideoTransition && (
                                        <div className="lesson-player-mask" data-testid="nextVideoTransition">
                                            <div className="lesson-player-mask-content">
                                                <Link
                                                    to={`/${course.slug}/${nextModule}/${nextLesson}`}
                                                    className="btn-next mb-2"
                                                    onClick={() => {
                                                        if (nextLesson !== parseInt(moduleId, 10) && nextLesson) {
                                                            handleOpenCloseDropdown(nextLesson);
                                                        }
                                                        setShowNextVideoTransition(false);
                                                    }}
                                                >
                                                    <ToroLearnIcon icon="play-circle" size={72} fill="white" />
                                                </Link>
                                                <p className="font-size-7">
                                                    A próxima aula começa em{' '}
                                                    <span className="font-weight-bold">{counter} segundos.</span>
                                                </p>
                                                <button
                                                    className="btn btn-outline-white btn-sm"
                                                    onClick={() => {
                                                        if (timeOutInstance) clearTimeout(timeOutInstance);
                                                        setShowNextVideoTransition(false);
                                                    }}
                                                >
                                                    Cancelar
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {!lesson.videoDistributionUrl && (
                                        <ToroLearnLockedPlayer setShowToroFormModal={setShowToroFormModal} />
                                    )}
                                </div>
                                <div className="lesson-info mt-4">
                                    <div className="row lesson-info-controls">
                                        <div className="col-lg-7">
                                            <h4 className="font-size-4">{lesson.name}</h4>
                                            <span>
                                                Aula {lessonId.padStart(2, '0')}
                                                <span
                                                    className={`badge ${
                                                        lesson.isCompleted ? 'badge-success' : 'badge-gray-dark'
                                                    } text-uppercase is-rounded ml-3 p-2`}
                                                    onClick={() => {
                                                        if (isLastModule && nextLesson === null) {
                                                            if (course?.id === (isDevOrHml ? idHml : idProd)) {
                                                                setShowSuccessScreen(true);
                                                            }
                                                        }
                                                    }}
                                                >
                                                    {lesson.isCompleted ? 'Concluída' : 'Não Concluída'}
                                                </span>
                                            </span>
                                        </div>
                                        <div className="lesson-info-control-buttons col-lg-5 d-flex justify-content-end">
                                            {!!prevLesson && (
                                                <div className="d-flex align-items-center">
                                                    <Link
                                                        to={`/${course.slug}/${prevModule}/${prevLesson}`}
                                                        className="mb-2"
                                                        data-testid="prevLessonButton"
                                                        onClick={() => {
                                                            handleLessonControllsClick('prev');
                                                            if (prevModule !== parseInt(moduleId, 10)) {
                                                                handleOpenCloseDropdown(prevModule);
                                                            }
                                                        }}
                                                    >
                                                        <div className="lesson-info-control-buttons-indicator-left mr-3">
                                                            <ToroLearnIcon
                                                                icon="keyboard-arrow-left"
                                                                size={14}
                                                                fill="gray-dark"
                                                            />
                                                        </div>
                                                    </Link>
                                                    <div className="d-block">
                                                        <small className="font-size-9">Módulo {prevModule}</small>
                                                        <p className="text-dark font-size-8">
                                                            Aula {prevLesson.toString().padStart(2, '0')}
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                            {!!nextLesson && (
                                                <div className="d-flex ml-5 align-items-center">
                                                    <div className="d-block">
                                                        <small className="font-size-9">Módulo {nextModule}</small>
                                                        <p
                                                            className="text-dark font-size-8"
                                                            data-testid="currNextLessonText"
                                                        >
                                                            Aula {nextLesson.toString().padStart(2, '0')}
                                                        </p>
                                                    </div>
                                                    <Link
                                                        to={`/${course.slug}/${nextModule}/${nextLesson}`}
                                                        className="mb-2"
                                                        data-testid="nextLessonButton"
                                                        onClick={() => {
                                                            handleLessonControllsClick('next');

                                                            if (nextLesson !== parseInt(moduleId, 10)) {
                                                                handleOpenCloseDropdown(nextLesson);
                                                            }
                                                        }}
                                                    >
                                                        <div className="lesson-info-control-buttons-indicator-right ml-3">
                                                            <ToroLearnIcon
                                                                icon="keyboard-arrow-right"
                                                                size={14}
                                                                fill="dark"
                                                            />
                                                        </div>
                                                    </Link>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4 bg-white px-5 mb-5">
                            <div className="container-fluid">
                                <div className="row position-relative">
                                    <div className={`lesson-description col-12 ${!lesson.resources && 'col-sm-8'}`}>
                                        <p className="font-size-7">{lesson.description || course.description}</p>
                                    </div>
                                    {lesson.resources && (
                                        <div className="col-12 col-sm-4 mb-4 mx-3">
                                            <div className="row justify-content-end">
                                                {lesson.resources.map(({ name, url }) => (
                                                    <ToroLearnResourceCard key={name} src={url} name={name} />
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {isLocked && !lesson.videoDistributionUrl && (
                                        <div className="description-mask"></div>
                                    )}
                                </div>

                                {!isLocked && lesson.cta && (
                                    <div className="col-12 col-sm-11">
                                        <ToroCTACard
                                            onClick={() => {
                                                trackingEvent.elementClicked({
                                                    productAreaOrigin: 'Aprenda',
                                                    element: 'Botão Acessar',
                                                    step: lesson?.cta?.title,
                                                    group: 'Explorar o conteúdo',
                                                    label: lesson?.name,
                                                    text: course?.name,
                                                    timeResponsavel: 'Sky',
                                                });
                                            }}
                                            link={lesson.cta.link}
                                            title={lesson.cta.title}
                                            subtitle={lesson.cta.subtitle}
                                        />
                                    </div>
                                )}

                                {isLocked && !lesson.videoDistributionUrl && (
                                    <div className="row justify-content-center mb-3">
                                        <div className="col-12 col-sm-11">
                                            <ToroLearnLockedCard setShowToroFormModal={setShowToroFormModal} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 border-left position-relative p-0">
                        <ToroLearnPlaylist />
                    </div>
                    {isLocked && <ToroLearnBuyFooter setShowToroFormModal={setShowToroFormModal} />}
                    {showToroFormModal && (
                        <ModalToroForm
                            showModal={showToroFormModal}
                            setShowModal={setShowToroFormModal}
                            registeredUser={isRegisteredUser}
                        />
                    )}
                </div>
            )}
        </>
    );
};
